var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatPasteGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.3306L13.6 15.9306L15.175 14.3306H11V12.3306H15.175L13.6 10.7306L15 9.33057L19 13.3306L15 17.3306ZM4 6.33057H12V4.33057H4V6.33057ZM4 10.3306H9V8.33057H4V10.3306ZM0 17.3306V2.33057C0 1.78057 0.195833 1.30973 0.5875 0.918066C0.979167 0.5264 1.45 0.330566 2 0.330566H14C14.55 0.330566 15.0208 0.5264 15.4125 0.918066C15.8042 1.30973 16 1.78057 16 2.33057V7.40557C15.8333 7.37223 15.6667 7.3514 15.5 7.34307C15.3333 7.33473 15.1667 7.33057 15 7.33057C13.3167 7.33057 11.8958 7.9139 10.7375 9.08057C9.57917 10.2472 9 11.6639 9 13.3306C9 13.4972 9.00417 13.6639 9.0125 13.8306C9.02083 13.9972 9.04167 14.1639 9.075 14.3306H3L0 17.3306Z",
    fill: "#67768B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPasteGo);
export default __webpack_public_path__ + "static/media/chat_paste_go.1760fb71d8c26d92711a16cd7fc4bd9d.svg";
export { ForwardRef as ReactComponent };